import { EntityType } from '../../../../components/workflow-sidebar/sidebar-views/editors/enroll-node/enroll-node.types';

export const formatEntityType = (entityType?: EntityType) => {
  switch (entityType) {
    case 'branchOfficeIds':
      return 'Branch Office';
    case 'jobTypeIds':
      return 'Job Type';
    default:
      return entityType;
  }
};

export const formatConditionsText = (condition: string) => {
  return condition === 'equal' ? '=' : condition;
};
